import ModalBox from "components/modal/ModalBox";
import NotFound from "components/not-found/NotFound";
import Switch from "components/Switch/Switch";
import useDebounce from "hooks/useDebounce";
import useFullPageLoader from "hooks/useFullPageLoader";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import Pagination from "react-js-pagination";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { dateFormat } from "utils";
import EditIcon from "@mui/icons-material/Edit";
import { Button } from "components/Button/Button";
import DeleteIcon from "@mui/icons-material/Delete";

import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import Tooltip from "components/Tooltip/Tooltip";
import { getCenters, updateCenterStatus } from "services/centers";
// import AddCenter from "./AddCenter";
// import UpdateCenter from "./UpdateCenter";
// import CenterLinkModal from "./sections/CenterLinkModal";
import { Table } from "react-bootstrap";
import CheckIcon from "@mui/icons-material/Check";
import { IconButton } from "@mui/material";
import { useAdminAuth } from "context/context";
import { cityWiseCenterStatus, cityWiseSectionDelete, cityWiseSectionDisplayOrder, getCityWiseCenters, getCityWiseSections, updateMasterStateStatus } from "services/citypages";
import AddCenterWiseCity from "../AddCityWiseCenter";
import UpdateCityWiseCenter from "../UpdateCityWiseCenter";
import CenterLinkModal from "pages/CenterManagement/sections/CenterLinkModal";
import MappedCityWiseCenters from "../MappedCityWiseCenters";
import { RemoveRedEye } from "@mui/icons-material";
import { Input } from "components/Form";
import AddCityWiseSection from "./AddCityWiseSection";
import UpdateCityWiseSection from "./UpdateCityWiseSection";
// import AddMasterState from "./AddMasterState";
// import UpdateMasterState from "./UpdateMasterState";

const CityWiseCenterSections = () => {
    const [searchParam, setSearchParam] = useSearchParams();
    let activePage = +searchParam.get("page") || 1;
    const [descModal, setDescModal] = useState(false);
    const [descContent, setDescContent] = useState("");
    const [editOrderId, setEditOrderId] = useState(null);
    const [newOrder, setNewOrder] = useState("");
    const [record, setRecord] = useState([]);
    const [total, setTotal] = useState(0);
    const navigate = useNavigate();
    const { id, city } = useParams();
    const [deleteModal, setDeleteModal] = useState(false);


    const { roles } = useAdminAuth();

    const [assignStatus, setAssignStatus] = useState({
        course: false,
        faq: false,
        video: false,
        subheading: false,
    });

    const [galleryImage, setGalleryImage] = useState([]);

    const [blockModal, setBlockModal] = useState(false);
    const [selectedId, setSelectedId] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [linkModal, setLinkModal] = useState(false);
    const [linkSelectedId, setLinkSelectedId] = useState("");

    const [addModal, setAddModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [selectedData, setSelectedData] = useState({});

    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

    const [search, setSearch] = useState(searchParam.get("query") || "");
    const debounceValue = useDebounce(search || "", 300);

    //**********centre Listing**********/
    const citywisecenterListing = async (page = activePage, search = debounceValue) => {
        try {
            showLoader();
            const res = await getCityWiseSections({
                page,
                search,
                cityid: id
            });
            hideLoader();
            if (res.code === 200) {
                const { citysections } = res.data;
                setRecord(citysections || []);
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err.message);
        }
    };

    // update status function
    const updateCityWiseCenterStatusHandler = async () => {
        if (selectedId) {
            try {
                setSubmitLoading(true);
                const res = await cityWiseCenterStatus({
                    id: selectedId,
                    status: selectedStatus ? 0 : 1,
                });
                if (res.code === 200) {
                    citywisecenterListing();
                    toast.success(res.message);
                    setBlockModal(false);
                    setSubmitLoading(false);
                } else {
                    toast.error(res.message);
                    setSubmitLoading(false);
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
                setSubmitLoading(false);
            }
        }
    };

    const handleUpdateDisplayOrder = async (sid, newOrder) => {
        try {
            showLoader();
            const res = await cityWiseSectionDisplayOrder({
                id: sid,
                cityid: id,
                displayorder: newOrder,
            });
            hideLoader();
            if (res.code === 200) {
                toast.success("Display order updated successfully");
                setEditOrderId(null);
                citywisecenterListing();
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err.message);
            hideLoader();
        }
    };

    // open link modal function
    const openLinkModalHandler = (data) => {
        setLinkSelectedId(data.id);
        console.log("isNewsAssigned", data.isNewsAssigned);

        setAssignStatus({
            course: data.isAssignedCourse,
            video: data.isVideoAssigned,
            news: data.isNewsAssigned,
            subheading: data.isSubHeadingAssigned
        });
        setLinkModal(true);
    };

    //*********Handel Pagination********* */
    const handlePageChange = (event) => {
        searchParam.set("page", event);
        setSearchParam(searchParam);
    };

    const handleDelete = async () => {
        showLoader();
        try {
            const res = await cityWiseSectionDelete({ id: selectedId, cityid: id });
            hideLoader();
            if (res.code === 200) {
                toast.success(res.message);
                setDeleteModal(false)
                citywisecenterListing();
            } else {
                setDeleteModal(false)
                citywisecenterListing();
                toast.error(res.message);
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err.message);
        }
        hideLoader();
    };

    //********Reset Filter****** */
    const restFilter = () => {
        setSearch("");
    };

    useEffect(() => {
        if (debounceValue) {
            searchParam.set("query", debounceValue);
        } else {
            searchParam.delete("query");
        }
        if (activePage === 1) {
            searchParam.delete("page");
        }
        setSearchParam(searchParam);
        citywisecenterListing(activePage, debounceValue);
        // eslint-disable-next-line
    }, [searchParam, debounceValue]);

    useEffect(() => {
        if (search) {
            searchParam.set("page", "");
        }
        // eslint-disable-next-line
    }, [search]);

    return (
        <React.Fragment>
            <title>Shubhra Viraj | City Wise Center Sections</title>
            <div className="">
                <div className="WrapperBox">
                    <div className="Small-Wrapper">
                        <div className="search_wrap">
                            <div className="SearchBox">
                                <div className="div_wrap">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        name="search"
                                        className="form-control"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>

                                <Button className="refresh_btnn mx-2" onClick={restFilter}>
                                    <i className="fa fa-refresh"></i>
                                </Button>
                                <div>
                                    <Button
                                        onClick={() => setAddModal(true)}
                                        type="acl"
                                        role={850002}
                                    >
                                        Add Section
                                    </Button>
                                </div>
                            </div>
                            <h4 className="Title">
                                <Link to={-1}>
                                    <i className="fa fa-arrow-left"></i>
                                </Link>
                                {city} Sections
                            </h4>
                        </div>
                        <div className="TableList overflow-auto table-responsive">
                            {loader}
                            <Table bordered className="table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Section </th>
                                        <th>Description</th>
                                        <th>Display Order</th>
                                        <th style={{ textAlign: "center" }}>H1 Tag</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {record && record.length > 0 ? (
                                        record.map(
                                            (
                                                {
                                                    id,
                                                    section,
                                                    description,
                                                    ish1tag,
                                                    displayorder,

                                                },
                                                i
                                            ) => (
                                                <tr key={i}>
                                                    <td>{++i + (activePage - 1) * 10}</td>
                                                    <td>
                                                        <Tooltip title={section}>
                                                            <div className="">{section}</div>
                                                        </Tooltip>
                                                    </td>
                                                    <td className="text-center">
                                                        <IconButton
                                                            aria-label="view-description"
                                                            className="px-2 py-0"
                                                            onClick={() => {
                                                                setDescContent(description || "");
                                                                setDescModal(true);
                                                            }}
                                                        >
                                                            <RemoveRedEye style={{ color: "#4971B2" }} />
                                                        </IconButton>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="d-flex align-items-center">
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                style={{ width: "80px" }}
                                                                value={displayorder}
                                                                onChange={(e) => {
                                                                    const val = e.target.value;
                                                                    setRecord((prev) =>
                                                                        prev.map((item) =>
                                                                            item.id === id ? { ...item, displayorder: val, _dirty: true } : item
                                                                        )
                                                                    );
                                                                }}
                                                            />

                                                            <IconButton
                                                                aria-label="save-order"
                                                                className="ms-2"   // 🔹 adds gap between input and icon
                                                                disabled={!record.find((r) => r.id === id)?._dirty}
                                                                onClick={() => handleUpdateDisplayOrder(id, displayorder)}
                                                                sx={{
                                                                    width: 20,
                                                                    height: 20,
                                                                    borderRadius: "50%",
                                                                    bgcolor: record.find((r) => r.id === id)?._dirty ? "green" : "grey.400",
                                                                    "&:hover": {
                                                                        bgcolor: record.find((r) => r.id === id)?._dirty ? "darkgreen" : "grey.500",
                                                                    },
                                                                }}
                                                            >
                                                                <CheckIcon sx={{ color: "white", fontSize: 13 }} />
                                                            </IconButton>
                                                        </div>
                                                    </td>



                                                    <td className="text-center">
                                                        <span
                                                            className={`badge ${ish1tag ? "bg-success" : "bg-danger"}`}
                                                            style={{ fontSize: "12px", padding: "4px 8px", minWidth: "40px" }}
                                                        >
                                                            {ish1tag ? "Yes" : "No"}
                                                        </span>
                                                    </td>



                                                    <td>
                                                        <div className="d-flex justify-content-center">
                                                            <IconButton
                                                                aria-label="view"
                                                                className="px-2 py-0"
                                                                onClick={() => {
                                                                    setSelectedData({ id, section, description, ish1tag });
                                                                    setUpdateModal(true);
                                                                }}


                                                                type="acl"
                                                                role={170002}
                                                            >
                                                                <EditIcon sx={{ color: "#4971B2" }} />
                                                            </IconButton>
                                                            <IconButton
                                                                aria-label="view"
                                                                className="px-1 py-0"
                                                                onClick={() => {
                                                                    setDeleteModal(true);
                                                                    setSelectedId(id);
                                                                }}
                                                            >
                                                                <DeleteIcon sx={{ color: "#ff0000" }} />
                                                            </IconButton>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        )
                                    ) : (
                                        <NotFound cols={12} />
                                    )}
                                </tbody>
                            </Table>
                        </div>
                        {total > 10 ? (
                            <div className="Pagination">
                                <Pagination
                                    activePage={activePage}
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    itemsCountPerPage={10}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>

            {/* block or unblock model */}
            <ModalBox
                status={blockModal}
                onClose={() => setBlockModal(false)}
                title={"Change Status"}
                description={"You want to change status of this city?"}
                customizedFooter={
                    <Button onClick={updateCityWiseCenterStatusHandler} {...submitButtonElement}>
                        Yes
                    </Button>
                }
            />
            <ModalBox
                status={descModal}
                onClose={() => setDescModal(false)}
                title={"Section Description"}
                size="md"   // 🔹 this makes modal wider (~900px)
                description={
                    <div dangerouslySetInnerHTML={{ __html: descContent }} />
                }
            />

            <AddCityWiseSection
                open={addModal}
                onClose={() => setAddModal(false)}
                cityId={id}
                citywisecenterListing={citywisecenterListing}
            />

            <UpdateCityWiseSection
                open={updateModal}
                onClose={() => setUpdateModal(false)}
                data={selectedData}
                cityId={id}
                citywisecenterListing={citywisecenterListing}
            />

            <ModalBox
                status={deleteModal}
                onClose={() => setDeleteModal(false)}
                title={"Delete Section"}
                size={"md"}
                description={"Are you sure want to delete this section ?"}
                customizedFooter={
                    <Button onClick={handleDelete} {...submitButtonElement}>
                        Delete
                    </Button>
                }
            />




        </React.Fragment>
    );
};

export default CityWiseCenterSections;
